import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import MoneyUtils from '../../utils/moneyUtils';
import Icon from '../AppIcon';

const QueueActionBanner = ({ 
  itemCount, 
  total, 
  onClick, 
  theme,
  isQueueMode,
  isFixed = true,
  isCompact = false
}) => {
  if (!isQueueMode || itemCount === 0) return null;

  const primaryColor = theme?.primary || '#fff';
  const secondaryColor = theme?.secondary || '#222';

  const content = (
    <AnimatePresence mode="wait">
      <motion.button
        key={isCompact ? 'compact' : 'expanded'}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2 }}
        onClick={onClick}
        className={`pointer-events-auto shadow-[0_15px_40px_rgba(0,0,0,0.08)] border border-gray-100 overflow-hidden cursor-pointer flex active:scale-[0.98] transition-all group ${
          isCompact 
            ? 'w-14 h-14 rounded-full items-center justify-center' 
            : `w-full max-w-lg mx-auto rounded-2xl flex-col ${!isFixed ? 'mb-2' : ''}`
        }`}
        style={{ backgroundColor: isCompact ? '#fff' : `${secondaryColor}25` }}
      >
        <div className={`flex items-center ${
          isCompact 
            ? 'w-full h-full justify-center' 
            : 'w-full bg-white/90 backdrop-blur-2xl rounded-[15px] justify-between px-4 py-3'
        }`}>
          <div className="flex items-center gap-3">
            <div className="relative">
              <div 
                className={`flex items-center justify-center border ${
                  isCompact ? 'w-full h-full border-none' : 'w-10 h-10 rounded-xl'
                }`}
                style={{ backgroundColor: isCompact ? 'transparent' : `${secondaryColor}15`, borderColor: `${secondaryColor}20` }}
              >
                 <span className={isCompact ? 'text-2xl' : 'text-xl'}>🥡</span>
              </div>
              <div className={`absolute bg-red-500 text-white text-[10px] font-black rounded-full border-2 border-white flex items-center justify-center shadow-sm ${
                isCompact ? '-top-1 -right-1 w-5 h-5' : '-top-1.5 -right-1.5 w-5 h-5'
              }`}>
                {itemCount}
              </div>
            </div>
            
            {!isCompact && (
              <div className="flex flex-col text-left">
                <span className="text-[9px] text-gray-400 font-bold uppercase tracking-[0.15em] leading-none mb-1">Building Pre-order</span>
                <span className="text-base font-black leading-tight mt-0.5" style={{ color: secondaryColor }}>
                  {MoneyUtils.format(total)}
                </span>
              </div>
            )}
          </div>

          {!isCompact && (
            <div 
              className="px-4 py-2 rounded-xl font-bold text-[10px] shadow-md flex items-center justify-center gap-2 uppercase tracking-widest transition-all min-w-[100px]"
              style={{ backgroundColor: secondaryColor, color: primaryColor }}
            >
              Join Queue
              <svg className="w-3 h-3 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          )}
        </div>
      </motion.button>
    </AnimatePresence>
  );

  if (!isFixed) return content;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 50, opacity: 0, scale: 0.95 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        exit={{ y: 50, opacity: 0, scale: 0.95 }}
        className="fixed bottom-0 left-0 right-0 p-4 pb-6 z-30 pointer-events-none"
      >
        {content}
      </motion.div>
    </AnimatePresence>
  );
};

export default QueueActionBanner;
